import { render, staticRenderFns } from "./OpenOfferDetails.vue?vue&type=template&id=b77a2c1e&"
import script from "./OpenOfferDetails.vue?vue&type=script&lang=js&"
export * from "./OpenOfferDetails.vue?vue&type=script&lang=js&"
import style0 from "./OpenOfferDetails.vue?vue&type=style&index=0&id=b77a2c1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports